export const backendUrl = 'https://backend.mostafiz.org/'
export const spacesBucketUrl = 'https://mostafiz.sgp1.cdn.digitaloceanspaces.com/'
